import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
// import store from '@/store'
// import { getToken } from '@/utils/auth'

// 创建一个axios实例
// let Const_Api_Root= 'https://baikem.tunnelling.cn/'
const service = axios.create({
  baseURL: Const_Api_Roots, // url = base url + request url
  // withCredentials: true, //当跨域请求时发送cookie
  timeout: 90000 // 请求超时
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // if (store.getters.token) {
    //   // 让每个请求携带令牌
    //   config.headers.common['Authorization'] = "Bearer " + store.getters.token
    // }
    return config
  },
  error => {
    // 处理请求错误
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  /**
   * 如果您想获得http信息，如头或状态
   * 请 return  response => response
  */

  /**
   * 通过自定义代码确定请求状态
   * 这里只是一个例子
   * 您也可以通过HTTP状态码来判断状态
   */

  response => {
    const res = response.data
    //如果定制代码不是20000，则判定为错误。
    if (!res.result && res.result != undefined) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      // 50008:非法令牌;50012:其他客户端登录;50014:令牌过期;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // 重新登陆
        MessageBox.confirm('您已注销，您可以取消停留在此页面，或重新登录', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          // store.dispatch('user/resetToken').then(() => {
          //   location.reload()
          // })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    // console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })

    //401 用户重新登录
    if(error.response && error.response.status == '401'){
      // 重新登陆
      MessageBox.confirm('您已注销，您可以取消停留在此页面，或重新登录', '提示', {
        confirmButtonText: '重新登陆',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // store.dispatch('user/resetToken').then(() => {
        //   location.reload()
        // })
      })
    }


    return Promise.reject(error)
  }
)

export default service
